import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class LabelledByBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.labelledBy = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let labelledBy = ko.unwrap(value);

                if (!labelledBy)
                    return;

                // Falls das Element noch keine ID besitzt, wird diese anhand des darüberliegenden Controls erzeugt
                if (!labelledBy.attr('id')) {
                    let parentControl = labelledBy.parents('.c-control').first();
                    labelledBy.attr('id', parentControl.data('control') + '-label-' + _.uniqueId())
                }

                element.removeAttr('aria-labelledby');
                element.attr('aria-labelledby', labelledBy.attr('id'));
            }
        };
    }
}